import { render, staticRenderFns } from "./comp-retorno-resumido.vue?vue&type=template&id=4a25656b&scoped=true"
import script from "./comp-retorno-resumido.vue?vue&type=script&lang=js"
export * from "./comp-retorno-resumido.vue?vue&type=script&lang=js"
import style0 from "./comp-retorno-resumido.vue?vue&type=style&index=0&id=4a25656b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25656b",
  null
  
)

export default component.exports